import React, { useState, useEffect } from 'react';

import FileBase from "react-file-base64"
// import { Benefit } from './index'
import { useDispatch } from 'react-redux';
import { createPartners, getPartners, deletePartner } from '../actions/partners';
import { useSelector } from 'react-redux';
import { FaTrash} from 'react-icons/fa';

type PropsFormPartner = {
    // ?: number;
    // set?: any;
};

const FormPartner: React.FC<PropsFormPartner> = () => {

    const [partnerData, setPartnerData] = useState({ title: '', link: '', image: '' });
    
    const partners = useSelector((state: any) => state.partners)

    const dispatch = useDispatch();

    const handleSubmitPartner = (e: any) => {
        e.preventDefault();
        
        dispatch(createPartners(partnerData));
        
        clearPartner();
    }
    
    const clearPartner = () => {
        setPartnerData({ title: '', link: '', image: ''});
    }

    useEffect(() => {
        dispatch(getPartners())
    }, [dispatch])
    

    return (
        <form className="_shadow-xl _bg-white _rounded-card _p-md _w-auto" onSubmit={handleSubmitPartner}>
            <h1 className="_text-center"> Créer un Partenaire </h1>
            <div className="_flex _flex-col">
                <input
                    className="_p-xs _rounded-md _my-sm _bg-gray"
                    type="text"
                    name="title"
                    value={partnerData.title}
                    placeholder="Nom du partenaire"
                    onChange={(e) => setPartnerData({ ...partnerData, title: e.target.value })}
                />
                <input
                    className="_p-xs _rounded-md _bg-gray _mb-sm"
                    name="link"
                    value={partnerData.link}
                    placeholder="lien du partenaire"
                    onChange={(e) => setPartnerData({ ...partnerData, link: e.target.value })}
                />
                <h2 className="_mb-sm"> Choisissez une image : </h2>
                <FileBase
                    type="file"
                    name="images"
                    multiple={false}
                    className="_p-xs _rounded-md _mb-sm _bg-gray"
                    onDone={({base64}) => setPartnerData({ ...partnerData, image: base64})}
                />
            </div>
            <section className="_flex _flex-col">
                <h1 className="_my-sm"> Liste des Partenaires </h1>
                <div className="_flex _flex-wrap">
                    {partners && (
                        partners.map((partner, i) => {
                            return (
                                <div>
                                    <div className="_m-xs _bg-green _bg-no-repeat _bg-cover _bg-center _rounded-md" style={{ height: '80px', width: '80px', backgroundImage: `url(${partner.image})` }}>
                                        {/* <div className="_m-s  _right-lg"> */}
                                        <button className="_ml-xs _text-warning _p-xxs hover:_bg-gray _rounded-card" type="button" onClick={() => dispatch(deletePartner(partner._id))}>
                                            <FaTrash />
                                        </button>
                                        {/* </div> */}
                                    </div>

                                </div>
                            )
                        }
                    ))}
                </div>
            </section>
            <div className="_flex _justify-end _mt-sm">
                <button type="reset" onClick={clearPartner}>Annuler </button>
                <button type="submit" className="_ml-sm _bg-green _rounded-md hover:_bg-darkengreen _text-white _font-bold _py-xs _px-sm _rounded-lg">
                    Créer
                </button>
            </div>
        </form>
    );
    
};

export default FormPartner;



